// extracted by mini-css-extract-plugin
export var childrenContainer = "_4i-0";
export var virtualScrollArea = "_4i-1";